import React from "react";
import products from "../data/wholesaleProducts";
import { ProductCard } from "./product";
import "../style/home.scss";

export default function Home({ shop, openProduct, openPolicy }) {
  const picks = [products[4], products[18], products[3], products[25]];
  return (
    <main className="home">
      <section className="hero">
        <div className="hero-orbit">
          <span>TRACEABLE</span>
          <span>GENTLE</span>
          <span>FAMILY FIRST</span>
        </div>
        <div className="hero-copy">
          <small>FROM FIRST DAYS TO BIG FEELINGS</small>
          <h1>
            Care that grows
            <br />
            <em>with your family.</em>
          </h1>
          <p>
            Thoughtful essentials for babies, children and mothers—made with
            purposeful ingredients, clear standards and plenty of tenderness.
          </p>
          <button onClick={() => shop("All")}>
            DISCOVER THE COLLECTION <b>↗</b>
          </button>
        </div>
        <button
          className="hero-product"
          onClick={() => openProduct(products[25])}
        >
          <img src={products[25].images[0]} alt={products[25].title} />
          <span>THE FAMILY WELCOME BOX</span>
          <b>$79</b>
        </button>
        <div className="hero-note">
          26 ORIGINAL ESSENTIALS
          <br />
          FOR REAL FAMILY LIFE
        </div>
      </section>
      <section className="chapter-nav">
        <p className="text-center">Shop by chapter</p>
        <div className="grid grid-cols-4 gap-4">
          {[
            ["Diapers", "01", "Soft landings"],
            ["Baby", "02", "Little rituals"],
            ["Kids", "03", "Growing independence"],
            ["Mama", "04", "Care for you"],
          ].map(([x, n, d]) => (
            <button key={x} onClick={() => shop(x)}>
              <span>{n}</span>
              <h2>{x}</h2>
              <small>{d}</small>
              <b>↗</b>
            </button>
          ))}
        </div>
      </section>
      <section className="favorites">
        <header>
          <span>MOST-LOVED RITUALS</span>
          <h2>
            Family favorites,
            <br />
            <em>gently reimagined.</em>
          </h2>
          <button onClick={() => shop("All")}>VIEW ALL 26</button>
        </header>
        <div className="editorial-grid">
          {picks.map((p, i) => (
            <ProductCard
              key={p.id}
              item={p}
              openProduct={openProduct}
              index={i}
            />
          ))}
        </div>
      </section>
      <section className="manifesto">
        <div className="manifesto-stamp">
          delmorian
          <br />
          <span>01 / 04</span>
        </div>
        <div>
          <small>OUR FORMULATION CHARTER</small>
          <h2>
            Less mystery.
            <br />
            More <em>meaning.</em>
          </h2>
          <p>
            We explain what each ingredient is doing, choose formats that feel
            good to use, and never dress an ordinary formula in extraordinary
            claims.
          </p>
          <button onClick={() => openPolicy("ingredients")}>
            READ OUR STANDARD ↗
          </button>
        </div>
        <ul>
          <li>
            <b>01</b>
            <span>Purpose before trend</span>
          </li>
          <li>
            <b>02</b>
            <span>Clear, complete labels</span>
          </li>
          <li>
            <b>03</b>
            <span>Skin-conscious testing</span>
          </li>
          <li>
            <b>04</b>
            <span>Right-sized packaging</span>
          </li>
        </ul>
      </section>
      <section className="routine">
        <div className="routine-copy">
          <small>A BETTER BEDTIME</small>
          <h2>
            Three small steps.
            <br />
            One softer landing.
          </h2>
          <p>
            Wash, moisturize, then slow down together. Our baby ritual keeps the
            routine simple so the goodnight can take its time.
          </p>
          <button onClick={() => shop("Baby")}>SHOP THE BABY RITUAL</button>
        </div>
        <div className="routine-products">
          {products.slice(5, 8).map((p, i) => (
            <button
              key={p.id}
              onClick={() => openProduct(p)}
              style={{ "--lift": `${i * 32}px` }}
            >
              <img src={p.images[0]} alt={p.title} />
              <span>
                0{i + 1} / {p.title}
              </span>
            </button>
          ))}
        </div>
      </section>
      <section className="journal">
        <header>
          <small>THE DELMORIAN LETTER</small>
          <h2>
            Notes for the
            <br />
            <em>beautifully unfinished.</em>
          </h2>
        </header>
        <div>
          {[
            ["01", "The diaper bag, edited: what earns its place"],
            ["02", "A slower bath ritual for busy evenings"],
            ["03", "Postpartum care without the pressure"],
          ].map(([n, t]) => (
            <article key={n}>
              <span>{n}</span>
              <h3>{t}</h3>
              <p>
                Practical, warm guidance for everyday family life—written
                without perfection, fear or filler.
              </p>
              <b>READ THE NOTE ↗</b>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
